import {KeycloakService} from './keycloak.service';
import {Injectable} from '@angular/core';

export function initializeKeycloak(o7KeycloakInitializer: O7KeycloakInitializer): () => Promise<boolean> {
  return o7KeycloakInitializer.initializeKeycloak();
}

@Injectable({
  providedIn: 'root'
})
export class O7KeycloakInitializer {

  constructor(private keycloakService: KeycloakService) {}

  initializeKeycloak(): () => Promise<boolean> {
    return (): Promise<boolean> => {
      this.keycloakService.setupAuthentication();
      return this.keycloakService.isAuthenticated();
    };
  }
}
